import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { ITeamOverview } from "../../interfaces";

export const useTeamOverview = () => {
  return useQuery<ITeamOverview, Error>({
    queryKey: ["stripe", "team-overview"],
    queryFn: async () => {
      const response = await httpService.get<ITeamOverview>(
        API_CONFIG.path.stripeTeamOverview
      );
      return response;
    },
  });
};
